import React, {createContext, useState} from "react";
import PropTypes from "prop-types";

export const PreferencesContext = createContext({});

export const PreferencesProvider = props => {
  // Initial values are obtained from the props
  const {
    subscriptions,
    uuid: initialUuid,
    email,
    children,
  } = props;

  const POCKET_HITS_NEWSLETTER = "Pocket Hits (English)";

  const pocketHitsSubscription = subscriptions.find((s) => s.newsletterName === POCKET_HITS_NEWSLETTER);

  // Use State to keep the values
  const [subscription, setSubscription] = useState(pocketHitsSubscription);
  const [uuid, setUuid] = useState(initialUuid);
  const [frequencyUpdateInFlight, updateFrequencyNetworkStatus] = useState(false);
  const [subscriptionUpdateInFlight, updateSubscriptionNetworkStatus] = useState(false);

  const updateFrequency = frequency => {
    setSubscription({
      ...subscription,
      frequency,
    })
  };

  const updateSubscribedStatus = newStatus => {
    setSubscription({
      ...subscription,
      status: newStatus
    })
  }

  // Make the context object:
  const preferencesContext = {
    subscription,
    setSubscription,
    uuid,
    setUuid,
    updateFrequency,
    frequencyUpdateInFlight,
    updateFrequencyNetworkStatus,
    updateSubscribedStatus,
    subscriptionUpdateInFlight,
    updateSubscriptionNetworkStatus
  };

  // pass the value in provider and return
  return <PreferencesContext.Provider value={preferencesContext}>{children}</PreferencesContext.Provider>;
};

export const {Consumer} = PreferencesContext;

PreferencesProvider.propTypes = {
  subscriptions: PropTypes.array,
  uuid: PropTypes.string,
  email: PropTypes.string,

};

PreferencesProvider.defaultProps = {
  subscriptions: [],
  uuid: '',
  email: '',
};
